import * as React from "react";

export const useRefValue = <V>(value: V): React.RefObject<V> => {
  const valueRef = React.useRef(value);
  valueRef.current = value;
  return valueRef;
}